export interface BaseRootObject {
    type: string;
    totalFeatures: number;
    numberMatched: number;
    numberReturned: number;
    timeStamp: string;
    crs: Crs;
}

export interface RootObject extends BaseRootObject {
    features: LinkFeature[];
}

export interface GeoserverAssetRootObject extends BaseRootObject {
    features: AssetFeature[];
}

export interface Crs {
    type: string;
    properties: Properties2;
}

export interface Properties2 {
    name: string;
}

export interface BaseFeature {
    type: string;
    geometry: Geometry;
    geometry_name: string;
}

export interface AssetFeature extends BaseFeature {
    id?: any;
    properties: GeoserverAssetProperties;
}

export interface LinkFeature extends BaseFeature {
    id: string;
    properties: GeoserverLinkProperties;
}

export interface ClusteredAsset extends BaseFeature {
    cluster: boolean;
    cluster_id: number;
    point_count_abbreviated: number;
    properties: ClusteredProperty[] | GeoserverAssetProperties;
}

export interface ClusteredProperty extends BaseFeature {
    properties: GeoserverAssetProperties;
}

export interface GeoserverAssetProperties {
    id: number;
    assetid: number;
    asset_config_id: number;
    selected: boolean;
    meta_data?: string;
    has_real_time_data: boolean;
    subasset_details?: string;
    name: string;
}

export interface GeoserverLinkProperties {
    id: number;
    to_node?: any;
    from_node?: any;
    curb_side?: any;
    bays_angle: string;
    bays_count: number;
    segment_id: string;
    street_name?: any;
    location_info?: any;
    bl_street_name: string;
    shst_location_start?: any;
    shst_location_end?: any;
    regulation_id: number;
    price?: any;
    time_limit?: number;
    regulationid: number;
    effective_dates_period: string;
    sub_activity_name: string;
    sub_activity_color: string;
    sub_activity_dash_style?: string;
    sub_activity_display_name?: string;
    sub_activity_disabled_color: string;
    sub_activity_filter_section?: string;
    sub_activity_disable_regulation: boolean;
    sub_activity_is_general_restriction: boolean;
    sub_activity_activity_name: string;
    sub_activity_activity_color: string;
}

export interface Geometry {
    type: string;
    coordinates: number[] | number[][];
}

export const defaultGeoserverData = {
    type: "",
    features: [],
    totalFeatures: 0,
    numberMatched: 0,
    numberReturned: 0,
    timeStamp: "",
    crs: {
        type: "",
        properties: {
            name: ""
        }
    }
};

export const defaultGeoserverAssetData: GeoserverAssetRootObject = {
    type: "",
    features: [],
    totalFeatures: 0,
    numberMatched: 0,
    numberReturned: 0,
    timeStamp: "",
    crs: {
        type: "",
        properties: {
            name: ""
        }
    }
};

export interface IGeoserverWMSData {
    type: string;
    features: GeoserverLinkProperties[];
    totalFeatures: number;
}

export type ITileRequestQueue = {
    url: string;
    tile: {
        signal: AbortSignal;
    };
    resolve: (value?: IGeoserverWMSData) => void;
    reject: (reason?: any) => void;
}[];

export interface IGeometryWithId {
    [id: number]: {
        id: number;
        geometry: Geometry;
    };
}

export interface IDictionaryGeoserverLinkProperties {
    [id: number]: GeoserverLinkProperties;
}
